<template>
  <v-dialog
    v-model="dialog"
    max-width="630"
    content-class="sc-modal sc-modal--md"
    scrollable
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        small
        text
        class="admin-add-btn"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon small class="mr-1">mdi-plus</v-icon>
        Adicionar produção
      </v-btn>
    </template>

    <v-card v-if="dialog" flat class="sc-modal__card">
      <v-btn icon class="sc-modal__close" @click="dialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <div class="sc-modal__header">
        <v-icon color="primary" class="mr-3">mdi-plus-circle</v-icon>
        <div>
          <span class="sc-modal__title">Adicionar produção</span>
          <span class="sc-modal__subtitle">Configure uma nova produção</span>
        </div>
      </div>

      <div class="sc-modal__body">
        <v-form
          @submit.prevent="inserirProducao"
          id="insert-producao-form"
          ref="myForm"
        >
            <div class="sc-modal__field">
              <label class="sc-modal__field-label">Nome *</label>
              <v-text-field
                placeholder="Ex: Bom dia São Paulo"
                solo flat dense
                hide-details="auto"
                v-model="nome_producao"
                :rules="rules.required"
                maxlength="40"
                counter="40"
                background-color="surface_tertiary"
              />
            </div>
            <div class="sc-modal__field">
              <label class="sc-modal__field-label">Sigla *</label>
              <v-text-field
                placeholder="Ex: BBB, GE, SPORTV..."
                solo flat dense
                hide-details="auto"
                v-model="sig_producao"
                :rules="rules.required"
                maxlength="64"
                counter="64"
                background-color="surface_tertiary"
                hint="Código único e permanente — não poderá ser alterado depois."
                persistent-hint
              />
            </div>
            <div v-if="pracas" class="sc-modal__field">
              <label class="sc-modal__field-label">Praça *</label>
              <v-select
                v-model="cod_praca"
                :items="pracas"
                placeholder="Selecione a praça"
                item-text="sig_praca"
                item-value="cod_praca"
                return-object
                @change="(e) => (cod_praca = Number(e.cod_praca))"
                solo flat dense
                hide-details
                background-color="surface_tertiary"
              />
            </div>
            <div class="sc-modal__field">
              <label class="sc-modal__field-label">Descrição</label>
              <v-textarea
                placeholder="Descrição opcional da produção"
                solo flat dense
                hide-details="auto"
                v-model="dsc_producao"
                background-color="surface_tertiary"
                no-resize
                rows="3"
              />
            </div>
            <div>
              <v-slider
                v-model="qtde_dias_retencao"
                hide-details
                min="1"
                max="7"
                label="Dias de retenção das colaborações"
                dense
                thumb-label
                thumb-color="primary"
                ticks="always"
                :tick-labels="ticksLabels"
              >
              </v-slider>
            </div>
            <div class="producao-toggles">
              <label class="sc-modal__field-label">Funcionalidades</label>
              <div class="producao-toggle-list">
                <div class="producao-toggle-item">
                  <div class="producao-toggle-info">
                    <span class="producao-toggle-name">Colaboração avulsa</span>
                    <span class="producao-toggle-desc">Envio direto pelo SocialCam</span>
                  </div>
                  <v-switch v-model="novaColaboracao" color="primary" hide-details dense class="mt-0 pt-0" />
                </div>
                <div class="producao-toggle-item">
                  <div class="producao-toggle-info">
                    <span class="producao-toggle-name">Receber retweets</span>
                  </div>
                  <v-switch v-model="receberRetweets" color="primary" hide-details dense class="mt-0 pt-0" />
                </div>
                <div class="producao-toggle-item">
                  <div class="producao-toggle-info">
                    <span class="producao-toggle-name">Mosaico de colaborações</span>
                    <span class="producao-toggle-desc">Exibição em tela cheia</span>
                  </div>
                  <v-switch v-model="mosaicoEnabled" color="primary" hide-details dense class="mt-0 pt-0" />
                </div>
                <div class="producao-toggle-item">
                  <div class="producao-toggle-info">
                    <span class="producao-toggle-name">Tarja de colaboração</span>
                    <span class="producao-toggle-desc">Fundo verde para exibição ao vivo</span>
                  </div>
                  <v-switch v-model="tarjaEnabled" color="primary" hide-details dense class="mt-0 pt-0" />
                </div>
                <div class="producao-toggle-item">
                  <div class="producao-toggle-info">
                    <span class="producao-toggle-name">Tarja de cronômetro</span>
                    <span class="producao-toggle-desc">Cronômetro em fundo verde</span>
                  </div>
                  <v-switch v-model="tarjaCronometro" color="primary" hide-details dense class="mt-0 pt-0" />
                </div>
                <div class="producao-toggle-item">
                  <div class="producao-toggle-info">
                    <span class="producao-toggle-name">Globo Graphics</span>
                    <span class="producao-toggle-desc">Cenas e playout Vizrt para esta produção</span>
                  </div>
                  <v-switch v-model="globographicsEnabled" color="primary" hide-details dense class="mt-0 pt-0" />
                </div>
              </div>
            </div>
          </v-form>
        </div>

        <div class="sc-modal__footer">
          <v-btn text @click="dialog = false" class="modal-btn-cancel">Cancelar</v-btn>
          <v-btn color="primary" type="submit" form="insert-producao-form" class="modal-btn-confirm">
            <v-icon small class="mr-1">mdi-check</v-icon>
            Salvar
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
</template>

<script>
import { apiClient } from "@/services/api";
export default {
  props: {
    fetchData: Function,
  },
  data() {
    return {
      ticksLabels: ["1", "2", "3", "4", "5", "6", "7"],
      qtde_dias_retencao: 1,
      dialog: false,
      sig_producao: "",
      nome_producao: "",
      dsc_producao: "",
      cod_praca: null,
      pracas: [],
      tarjaCronometro: false,
      novaColaboracao: false,
      receberRetweets: false,
      mosaicoEnabled: false,
      tarjaEnabled: false,
      globographicsEnabled: false,
      dsc_login_producao: "",
      rules: {
        required: [(value) => !!value || "Required."],
      },
    };
  },

  watch: {
    dialog(open) {
      if (open) this.resetForm();
    },
  },
  created() {
    this.dsc_login_producao = this.$store.state.users.user.dsc_login_usuario;
    this.getPracas();
  },
  methods: {
    resetForm() {
      this.sig_producao = "";
      this.nome_producao = "";
      this.dsc_producao = "";
      this.cod_praca = null;
      this.qtde_dias_retencao = 1;
      this.tarjaCronometro = false;
      this.novaColaboracao = false;
      this.receberRetweets = false;
      this.mosaicoEnabled = false;
      this.tarjaEnabled = false;
      this.globographicsEnabled = false;
    },
    async getPracas() {
      await apiClient.get("/listarPracas").then((response) => {
        this.pracas = response.data.pracas;
      });
    },
    async inserirProducao() {
      if (this.sig_producao.trim() === "") {
        this.$toast.error("Informe a sigla da produção.");
        return;
      }
      if (this.sig_producao.trim().length > 64) {
        this.$toast.error("A sigla deve ter no máximo 64 caracteres.");
        return;
      }
      if (this.nome_producao.trim() === "") {
        this.$toast.error("Informe o nome da produção.");
        return;
      }
      try {
        const response = await apiClient.post("/inserirProducao", {
          sig_producao: this.sig_producao.toUpperCase(),
          nome_producao: this.nome_producao.trim(),
          dsc_producao: this.dsc_producao,
          dsc_login_producao: this.dsc_login_producao,
          cod_praca: this.cod_praca,
          qtd_dias_retencao_mensagens: this.qtde_dias_retencao,
          settings: {
            colaboracao: {
              nova_colaboracao: !!this.novaColaboracao,
              receber_retweets: !!this.receberRetweets,
            },
            tarja: {
              enabled: !!this.tarjaEnabled,
              cronometro: !!this.tarjaCronometro,
            },
            mosaico: {
              enabled: !!this.mosaicoEnabled,
            },
            globographics: {
              enabled: !!this.globographicsEnabled,
            },
            enquete: {},
          },
        });

        if (response.status === 200) {
          this.$toast.success("Produção criada com sucesso!");
          this.fetchData({});
          this.dialog = false;
          this.resetForm();
        }
      } catch (error) {
        const erro = error.response?.data?.erro || "";
        if (/duplicate/i.test(erro)) {
          this.$toast.error("Já existe uma produção com essa sigla.");
        } else {
          this.$toast.error("Erro ao criar produção...");
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.producao-toggles { margin-top: var(--sc-space-2); }
.producao-toggle-list { display: flex; flex-direction: column; gap: var(--sc-space-1); margin-top: var(--sc-space-2); }
.producao-toggle-item {
  display: flex; align-items: center; justify-content: space-between;
  padding: var(--sc-space-2) var(--sc-space-3); background: var(--sc-surface-tint-subtle);
  border-radius: var(--sc-radius-md); transition: background var(--sc-duration-fast) var(--sc-easing-standard);
  &:hover { background: var(--sc-surface-tint-hover); }
}
.producao-toggle-info { display: flex; flex-direction: column; gap: var(--sc-space-1); }
.producao-toggle-name { font-size: var(--sc-text-base); font-weight: var(--sc-weight-medium); color: var(--v-text_primary-base); }
.producao-toggle-desc { font-size: var(--sc-text-sm); color: var(--v-text_secondary-base); }
::v-deep .v-input--switch { margin: 0; padding: 0; }
</style>
